module.exports = __webpack_public_path__ + "static/media/26-2.04ea5b90.mp3";